import { useStoreRef } from '../../interpreter/hooks/useStoreRef';
import { hudStore } from '../../store/sceneStore';

interface HudData {
	speed: number;
	[key: string]: any;
}

export const CurrentSpeed = () => {
	const speedRef = useStoreRef<HudData, number>(
		hudStore,
		(s) => s.data.speed,
		(v) => v,
	);

	return (
		<div className='flex flex-col items-center justify-between w-full h-full'>
			<span className='text-zinc-400 text-6xl font-bold mb-4'>현재 속도</span>
			<div className='flex flex-col items-center justify-center relative h-full'>
				<span
					className='text-[16rem] leading-none font-bold tabular-nums tracking-tight'
					ref={speedRef}
				/>
				<span className='text-5xl text-zinc-500 font-medium mt-4'>km/h</span>
			</div>
		</div>
	);
};
